import { Mail, Home } from 'react-feather'
import ApiGate from './ApiGateway'
import Arc from './Arsip'
import Communication from './Communication'
import Helpdesk from './Helpdesk'
import komparasi from './komparasi'
import { laporan } from './Laporan'
import ManajemenLaporan from './ManajemenLaporan'
import Organisasi from './orgranisasi'
import RegisterDocuments from './RegisterDocuments'
import ScoreWorker from './ScoreWorker'
import Settings from './Settings'
import TaskManagement from './TaskManagement'

let menuText = localStorage.getItem("menu")
let menuJSON = JSON.parse(menuText)
let menuList = []

if (menuJSON != null || menuJSON != undefined) {
  menuJSON.map((data, index) => {
    if (data.label == 'Dashboard') {
      menuList.push({
        id: 'home',
        title: 'Dashboard',
        icon: <Home size={20} />,
        navLink: '/dashboard'
      })
    } else if (data.label == 'Laporan') {
      menuList.push(...laporan)
    } else if (data.label == 'Manajement Laporan') {
      menuList.push(...ManajemenLaporan)
    } else if (data.label == 'Komparasi Data') {
      menuList.push(...komparasi)
    } else if (data.label == 'Arsip') {
      menuList.push(...Arc)
    } else if (data.label == 'Struktur Organisasi') {
      menuList.push(...Organisasi)
    } else if (data.label == 'Komunikasi') {
      menuList.push(...TaskManagement)
    } else if (data.label == 'Manajemen Task') {
      menuList.push(...Communication)
    } else if (data.label == 'Pengaturan') {
      menuList.push(...Settings)
    } else if (data.label == 'Informasi & Bantuan') {
      menuList.push(...Helpdesk)
    } else if (data.label == 'Penilaian Pegawai') {
      menuList.push(...ScoreWorker)
    } else if (data.label == 'Registrasi Dokumen') {
      menuList.push(...RegisterDocuments)
    } else if (data.label == 'Api Dokumentasi') {
      menuList.push(...ApiGate)
    }

  })
}

export default menuList